var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcca19",
    d: "M456.513 213.555h-23.655v222.01c0 2.91-2.392 5.277-5.331 5.277H66.621c-2.94 0-5.331-2.367-5.331-5.277v-222.01H37.635c-2.793 0-5.078 2.285-5.078 5.076v244.975c0 2.791 2.285 5.074 5.078 5.074h418.878c2.793 0 5.078-2.283 5.078-5.074V218.631c0-2.791-2.285-5.076-5.078-5.076z",
    opacity: 1,
    "data-original": "#08a9f1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0290cf",
    d: "M63.026 463.605V440.72c-1.648-1.137-2.735-3.025-2.735-5.156v-222.01H37.635c-2.793 0-5.078 2.285-5.078 5.076v244.975c0 2.791 2.285 5.074 5.078 5.074h30.469c-2.793.001-5.078-2.282-5.078-5.074z",
    opacity: 1,
    "data-original": "#0290cf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe646f",
    d: "M199.986 440.842v69.594c0 1.676.96 2.068 2.134.873l20.857-21.24a2.991 2.991 0 0 1 4.27 0l20.859 21.24c1.174 1.195 2.134.803 2.134-.873v-69.594z",
    opacity: 1,
    "data-original": "#fe646f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd4755",
    d: "M199.986 440.842v69.594c0 1.676.96 2.068 2.134.873l18.178-18.512v-51.955z",
    opacity: 1,
    "data-original": "#fd4755"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efe2dd",
    d: "M427.527 183.234h-23.863c-6.463 8.396-14.737 15.541-24.472 20.82a4.033 4.033 0 0 0-2.082 2.984l-4.103 29.91c-.137 1.004-1.035 1.76-2.09 1.76h-4.525v22.34a4.08 4.08 0 0 1-4.077 4.074h-6.743v21.58a4.081 4.081 0 0 1-4.078 4.076h-20.415a4.081 4.081 0 0 1-4.078-4.076v-21.58h-6.74a4.08 4.08 0 0 1-4.078-4.074v-22.34h-4.524c-1.056 0-1.955-.756-2.092-1.76l-4.102-29.91a4.046 4.046 0 0 0-2.083-2.986c-9.734-5.277-18.008-12.422-24.471-20.818H66.621c-3.482 0-6.331 2.822-6.331 6.277v246.053c0 3.455 2.849 6.277 6.331 6.277h360.905c3.483 0 6.331-2.822 6.331-6.277V189.512c.001-3.455-2.847-6.278-6.33-6.278z",
    opacity: 1,
    "data-original": "#efe2dd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3eae6",
    d: "M66.621 183.234c-3.482 0-6.331 2.822-6.331 6.277v246.053c0 3.455 2.849 6.277 6.331 6.277H250.24V183.234z",
    opacity: 1,
    "data-original": "#f3eae6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1d3ce",
    d: "M85.68 435.565V189.512c0-3.455 2.849-6.277 6.332-6.277H66.621c-3.482 0-6.331 2.822-6.331 6.277v246.053c0 3.455 2.849 6.277 6.331 6.277h25.391c-3.483 0-6.332-2.822-6.332-6.277z",
    opacity: 1,
    "data-original": "#e1d3ce"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9e9797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.193 234.965h-51.921c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h51.921a7.5 7.5 0 0 1 0 15zM203.256 277.037h-95.984c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h95.984c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zM203.256 307.973h-95.984c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h95.984c4.143 0 7.5 3.357 7.5 7.5a7.5 7.5 0 0 1-7.5 7.5zM203.256 338.908h-95.984c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h95.984c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zM203.256 369.844h-95.984a7.5 7.5 0 0 1-7.5-7.5c0-4.143 3.357-7.5 7.5-7.5h95.984c4.143 0 7.5 3.357 7.5 7.5a7.5 7.5 0 0 1-7.5 7.5zM203.256 400.781h-95.984a7.5 7.5 0 0 1-7.5-7.5c0-4.143 3.357-7.5 7.5-7.5h95.984c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5zM389.279 338.908h-95.984c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h95.984c4.143 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5zM389.279 369.844h-95.984a7.5 7.5 0 0 1-7.5-7.5c0-4.143 3.357-7.5 7.5-7.5h95.984a7.5 7.5 0 0 1 0 15zM389.279 400.781h-95.984a7.5 7.5 0 0 1-7.5-7.5c0-4.143 3.357-7.5 7.5-7.5h95.984c4.143 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#9e9797",
    opacity: 1,
    "data-original": "#9e9797"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5a5a",
    d: "M325.999 265.123v21.58c0 2.791 2.285 5.076 5.078 5.076h20.415c2.793 0 5.078-2.285 5.078-5.076v-21.58z",
    opacity: 1,
    "data-original": "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M340.999 286.703v-21.58h-15v21.58c0 2.791 2.285 5.076 5.078 5.076h15c-2.792 0-5.078-2.285-5.078-5.076z",
    opacity: 1,
    "data-original": "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e9797",
    d: "M315.181 238.709v22.34c0 2.791 2.285 5.074 5.078 5.074h42.055c2.793 0 5.077-2.283 5.077-5.074v-22.34z",
    opacity: 1,
    "data-original": "#9e9797"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#766e6e",
    d: "M335.181 261.049v-22.34h-20v22.34c0 2.791 2.285 5.074 5.078 5.074h20c-2.793 0-5.078-2.283-5.078-5.074z",
    opacity: 1,
    "data-original": "#766e6e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc48",
    d: "M311.657 239.709c-1.562 0-2.877-1.119-3.083-2.623l-4.102-29.91a3.039 3.039 0 0 0-1.567-2.242c-25.031-13.572-40.582-39.305-40.582-67.148 0-42.361 35.421-76.82 78.963-76.82s78.965 34.459 78.965 76.82c0 27.844-15.551 53.576-40.582 67.148a3.029 3.029 0 0 0-1.567 2.242l-4.105 29.91c-.204 1.504-1.523 2.623-3.08 2.623z",
    opacity: 1,
    "data-original": "#ffdc48",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc48",
    d: "M311.657 239.709c-1.562 0-2.877-1.119-3.083-2.623l-4.102-29.91a3.039 3.039 0 0 0-1.567-2.242c-25.031-13.572-40.582-39.305-40.582-67.148 0-42.361 35.421-76.82 78.963-76.82s78.965 34.459 78.965 76.82c0 27.844-15.551 53.576-40.582 67.148a3.029 3.029 0 0 0-1.567 2.242l-4.105 29.91c-.204 1.504-1.523 2.623-3.08 2.623z",
    opacity: 1,
    "data-original": "#ffdc48",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac600",
    d: "M277.556 153.012c0-42.361 35.421-76.82 78.964-76.82 18.236 0 35.036 6.061 48.418 16.199-14.385-19.039-37.555-31.426-63.652-31.426-43.542 0-78.963 34.459-78.963 76.82 0 23.91 11.476 46.258 30.568 60.691-9.791-12.978-15.335-28.845-15.335-45.464z",
    opacity: 1,
    "data-original": "#fac600",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb8801",
    d: "M397.827 46.588a7.5 7.5 0 0 1-6.481-11.264l8.416-14.504a7.499 7.499 0 0 1 10.251-2.725 7.502 7.502 0 0 1 2.724 10.252l-8.416 14.504a7.494 7.494 0 0 1-6.494 3.737zM284.107 46.955a7.496 7.496 0 0 1-6.47-3.695l-8.512-14.453a7.499 7.499 0 0 1 2.657-10.267 7.504 7.504 0 0 1 10.269 2.656l8.512 14.453a7.502 7.502 0 0 1-6.456 11.306z",
    opacity: 1,
    "data-original": "#fb8801"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac600",
    d: "M242.6 88.205a7.47 7.47 0 0 1-3.687-.973l-14.685-8.309a7.5 7.5 0 0 1-2.834-10.221 7.498 7.498 0 0 1 10.221-2.834l14.685 8.309a7.5 7.5 0 0 1-3.7 14.028z",
    opacity: 1,
    "data-original": "#fac600",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb8801",
    d: "M471.944 144.059h-16.929c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h16.929a7.5 7.5 0 0 1 0 15zM227.557 144.059h-16.928c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h16.928c4.143 0 7.5 3.357 7.5 7.5a7.5 7.5 0 0 1-7.5 7.5z",
    opacity: 1,
    "data-original": "#fb8801"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac600",
    d: "M340.956 31.723a7.5 7.5 0 0 1-7.5-7.5V7.5c0-4.143 3.357-7.5 7.5-7.5a7.5 7.5 0 0 1 7.5 7.5v16.723a7.5 7.5 0 0 1-7.5 7.5z",
    opacity: 1,
    "data-original": "#fac600",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fea613",
    d: "M341.286 165.594c-2.605 0-5.12-.381-7.498-1.076v75.191h15v-75.193a26.639 26.639 0 0 1-7.502 1.078z",
    opacity: 1,
    "data-original": "#fea613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb8801",
    d: "M367.727 139.381c0 14.475-11.838 26.213-26.441 26.213-14.604 0-26.44-11.738-26.44-26.213 0-14.477 11.836-26.211 26.44-26.211 14.603 0 26.441 11.734 26.441 26.211z",
    opacity: 1,
    "data-original": "#fb8801"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7701",
    d: "M334.846 139.381c0-10.969 6.796-20.356 16.44-24.266a26.535 26.535 0 0 0-10-1.945c-14.604 0-26.44 11.734-26.44 26.211 0 14.475 11.836 26.213 26.44 26.213 3.54 0 6.914-.695 10-1.947-9.644-3.911-16.44-13.301-16.44-24.266z",
    opacity: 1,
    "data-original": "#fe7701"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac600",
    d: "M443.354 87.572a7.5 7.5 0 0 1-3.743-14.004l14.633-8.406a7.498 7.498 0 0 1 10.239 2.768 7.498 7.498 0 0 1-2.767 10.238l-14.633 8.406a7.449 7.449 0 0 1-3.729.998z",
    opacity: 1,
    "data-original": "#fac600",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.1357be8eb3606c52c6f9ed216744a263.svg";
export { ForwardRef as ReactComponent };